import * as React from "react";
import {Box, Container, Typography} from "@mui/material";
import PageHeader from "../components/modern/PageHeader";
import RacePromo from "../components/modern/RacePromo";
import SectionTitle from "../components/modern/SectionTitle";
import Reveal from "../components/modern/Reveal";
import useFeaturedRace from "../components/modern/useFeaturedRace";
import {dateRange} from "../components/modern/format";
import races from "../store/races";

const IMG = process.env.PUBLIC_URL + "/images/course2027/";
const gallery = ["g1", "g2", "children", "g4", "g5"];

/* Page "Course" : course FIS & Children 2027 + archives */
export default function SwissChamps() {
    const race = useFeaturedRace();
    return (
        <>
            <PageHeader title={race.title} subtitle={`${dateRange(race.start, race.end)} – ${race.subtitle}`} image={race.image}/>
            <RacePromo full/>

            <Box component="section" sx={{py: {xs: 8, md: 10}}}>
                <Container maxWidth="lg">
                    <SectionTitle kicker="En images" title="L'ambiance de course"/>
                    <Box sx={{display: "grid", gridTemplateColumns: {xs: "1fr 1fr", md: "repeat(3, 1fr)"}, gridAutoRows: {xs: 150, md: 240}, gap: 1.5}}>
                        {gallery.map((g, i) => (
                            <Reveal key={g} delay={i * 80} style={{gridRow: i === 0 ? "span 2" : undefined, borderRadius: 16, overflow: "hidden"}}>
                                <img src={`${IMG}${g}.jpg`} alt="Course de télémark" loading="lazy"
                                     style={{width: "100%", height: "100%", objectFit: "cover", transition: "transform .6s"}}
                                     onMouseOver={e => (e.currentTarget.style.transform = "scale(1.06)")}
                                     onMouseOut={e => (e.currentTarget.style.transform = "")}/>
                            </Reveal>
                        ))}
                    </Box>
                </Container>
            </Box>

            {races.length > 0 && (
                <Box component="section" sx={{py: {xs: 8, md: 10}, bgcolor: "#fff"}}>
                    <Container maxWidth="lg">
                        <SectionTitle kicker="Archives" title="Éditions précédentes"/>
                        <Box sx={{display: "grid", gridTemplateColumns: {xs: "1fr", md: "1fr 1fr"}, gap: 3}}>
                            {races.map(r => (
                                <Reveal key={r.title}>
                                    <Box sx={{borderRadius: 4, overflow: "hidden", bgcolor: "#000", maxWidth: 520}}>
                                        <img src={IMG + "affiche-finals2025.jpg"} alt={r.title} loading="lazy" style={{width: "100%", display: "block"}}/>
                                    </Box>
                                    <Typography sx={{fontWeight: 700, mt: 1.5}}>{r.title}</Typography>
                                </Reveal>
                            ))}
                        </Box>
                    </Container>
                </Box>
            )}
            {/* Bandeau partenaires retiré momentanément : réactiver avec <Partners/> */}
        </>
    );
}
